var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.58772 8.16667V24.5H0.429825V8.16667H5.58772ZM0 2.97797C0 2.17015 0.294371 1.47187 0.883121 0.883121C1.47187 0.294371 2.17699 0 2.9985 0C3.83371 0 4.54567 0.294371 5.13442 0.883121C5.72317 1.45818 6.01754 2.1633 6.01754 2.9985C6.01754 3.83371 5.72317 4.54567 5.13442 5.13442C4.55936 5.72317 3.85424 6.01754 3.01904 6.01754C2.18384 6.01754 1.47187 5.72317 0.883121 5.13442C0.294371 4.54567 0 3.82686 0 2.97797Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16699 8.16664H12.6708V10.4983C14.2385 8.94384 16.5165 7.73682 18.4828 7.73682C21.601 7.73682 24.5003 9.38417 24.5003 15.9035V24.5H19.3424V16.7631C19.3424 14.85 19.2578 14.0389 18.7264 13.3082C18.2082 12.5642 17.6948 12.1922 16.7562 12.1922C14.9243 12.1922 14.212 12.6838 13.5875 13.6669C12.9764 14.6368 13.5305 24.5 13.5305 24.5H8.16699L8.16699 8.16664Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.7b5467a3810420b72726272194cbaeb3.svg";
export { ForwardRef as ReactComponent };